import React from 'react';
import { motion } from 'framer-motion';
import './ProgressBar.css';

const ProgressBar = ({ progress, color = '#00a896' }) => {
  return (
    <div className="progress-container">
      <div className="progress-background">
        <motion.div 
          className="progress-bar"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.5 }}
          style={{ backgroundColor: color }}
        />
      </div>
      
      <div className="progress-labels">
        <span>0% completado</span>
        <span>{Math.round(progress)}% completado</span>
      </div>
    </div>
  );
};

export default ProgressBar;
